import config from '@/config/config';

export function createService<T>(
  serviceName: string,
  ApiService: new () => T,
  MockService: new () => T
): T {
  return config.mockServices.includes(serviceName)
    ? new MockService()
    : new ApiService();
}
